import React, { useState, useEffect } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css"; 
import './style.css';
import './bootstrap.min.css';

function Gallery() {
    const [index, setIndex] = useState(-1);

    useEffect(() => {
        // பக்கத்தின் மெட்டா தகவல்கள்
        document.title = "Our Projects Gallery | Unicell Technologies Limited";
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', "View photos of our global paper mill operations, recycling plants, and industrial projects in South Africa, USA, UAE, and Zambia.");
        }
    }, []);

 
    return (
<>
         <div className="container-fluid bg-primary py-5 bg-header">
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">Our Gallery</h1>
                    <a href="" className="h5 text-white">Home</a>
                    <i className="far fa-circle text-white px-2"></i>
                    <a href="" className="h5 text-white">Our Gallery

                    </a>
                </div>
            </div>
        </div>
         <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="container py-5">
         
            <div className="row g-5">
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
                    <div className="team-item bg-light rounded overflow-hidden">
                        <div className="text-center py-4">
                            <h4 className="text-primary">ZAMBIA</h4>
                        </div>
                        <div className="team-img position-relative overflow-hidden">
                            <img className="img-fluid w-100" src="img/Zambi.png" alt="" />
                          
                        </div>
                     
                    </div>
                    
                </div>
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                    
                    <div className="section-title position-relative pb-3 mb-5">
                        <h1 className="mb-0">ZAMBEZI PAPER  MILLS LTD.</h1>
                    </div>
                    <p className="mb-4 text-center">Zambezi Paper Mills Ltd operates a Kraft paper and Tissue paper 
                        production facility through recycling of waste paper. The mill is a circular business with high impact on ESG.</p>
                   
                    <p className="mb-4 text-center">THE MILL HAS 2 PAPER MACHINES AND MANUFACTURES FOR LOCAL AND EXPORT MARKETS. ZAMBEZI PAPER MILLS LTD WAS ESTABLISHED IN 1979 WITH EUROPEAN MACHINERY TO MANUFACTURE HYGIENIC TISSUE AND PACKAGING PAPER FROM 100% RECYCLING OF WASTEPAPER, WHICH IS COLLECTED LOCALLY IN ZAMBIA AND IMPORTED FROM THE REGION ON REGULAR BASIS. 
                    </p>
                    <p className="mb-4 text-center">THE COMPANY HAS TWO WASTEPAPER DEPOTS BASED IN NDOLA AND LUSAKA. 
                    </p>

                    
                </div>
               
            </div>

            <div className="row g-5 mt-2">
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">

                    <div className="section-title position-relative pb-3 mb-5">
                        <h1 className="mb-0">SWAZI PAPER MILLS LTD. 
                        </h1>
                    </div>
                    <p className="mb-4 text-center">SPML WAS SET UP IN 1986 IN SWAZILAND TO MANUFACTURE KRAFT AND TISSUE PAPER.  THE UNIT WAS DESIGNED TO CATER TO SOUTH AFRICAN MARKETS BUT HAD TO BE SET UP IN SWAZILAND AS IN APARTHEID SOUTH AFRICA IT WAS NOT POSSIBLE FOR A “BROWN “COMPANY TO OWN THIS BUSINESS AGAINST ESTABLISHED ENTITIES. THE PLANT BUILT ON A 200-ACRE SITE WITH 2 KRAFT MACHINES + 4 TISSUE PAPER MACHINES WITH WASTEPAPER RECYCLING FACILITY.  NAMPAK GROUP OF SOUTH AFRICA BOUGHT THE TISSUE PAPER BUSINESS AND PLANT IN A PRIVATE DEAL IN 2008 WHEN THE GROUP HAD BECOME MAJOR THREAT WITH ABOUT 23% MARKET SHARE IN SOUTHERN AFRICA.  
                    </p>
                    
                    
                </div>
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                    
                    <div className="team-item bg-light rounded overflow-hidden">
                        <div className="text-center py-4">
                            <h4 className="text-primary">SWAZILAND</h4>
                        </div>
                        <div className="team-img position-relative overflow-hidden">
                            <img className="img-fluid w-100" src="img/swaziland.png" alt="" />
                          
                        </div>
                     
                    </div>
                   

                    
                </div>
               
            </div>


            <div className="row g-5 mt-2">
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
                    <div className="team-item bg-light rounded overflow-hidden">
                        <div className="text-center py-4">
                            <h4 className="text-primary">UNITED ARAB 
                                EMIRATES
                                </h4>
                        </div>
                        <div className="team-img position-relative overflow-hidden">
                            <img className="img-fluid w-100" src="img/uae.png" alt="" />
                          
                        </div>
                     
                    </div>
                    
                </div>
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                    
                    <div className="section-title position-relative pb-3 mb-5">
                        <h1 className="mb-0">EMIRATES PAPER MILLS LTD.</h1>
                    </div>
                    <p className="mb-4 text-center">EPML BEGAN OPERATING IN JEBEL ALI FREE ZONE FROM 1995 PRODUCING 20,000 TONS OF TISSUE PAPER JUMBO ROLLS AND SUPPLIED MANY DOWNSTREAM CONVERTING COMPANIES IN THE REGION. THE TISSUE PAPER PRODUCED WERE BATH TISSUE, FACIAL TISSUE, KITCHEN TOWELS, INDUSTRIAL TOWELS AND NAPKINS. THE MILL OPERATIONS WERE CLOSED DUE TO THE EXPANSION OF THE PORT OF JEBEL ALI AND THE PLANT WAS RELOCATED.
                    </p>
                    

                    
                </div>
               
            </div>




            <div className="row g-5 mt-2">
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">

                    <div className="section-title position-relative pb-3 mb-5">
                        <h1 className="mb-0">UNICELL PAPER MILLS, INC. 
                            USA
                            
                        </h1>
                    </div>
                    <p className="mb-4 text-center">A PART OF THE FAMILY ENTERED THE NORTH AMERICAN MARKET IN 2000 TO ESTABLISH A GREENFIELD TISSUE MILL PROJECT. THE MILL CAPACITY AT 25,000 TONS PER YEAR BUILT AT A COST OF $35 MILLION, UNICELL PAPER MILLS, INC WENT ONTO PRODUCE ONE OF THE HIGHEST QUALITIES OF TISSUE PAPER IN THE UNITED STATES, WITH CUSTOMER BASE RANGING FROM KIMBERLY CLARK, GEORGIA PACIFIC, SCA AND MANY BLUE-CHIP CLIENTS. THE MILL SUCCESSFULLY AND PROFITABLY OPERATED UNTIL 2005, WHEN A LARGE GROUP ACQUIRED THE MILL.

                    </p>
                    
                    
                </div>
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                    
                    <div className="team-item bg-light rounded overflow-hidden">
                        <div className="text-center py-4">
                            <h4 className="text-primary">UNITED STATES 
                                OF AMERICA
                                </h4>
                        </div>
                        <div className="team-img position-relative overflow-hidden">
                            <img className="img-fluid w-100" src="img/usa.png" alt="" />
                          
                        </div>
                     
                    </div>
                   

                    
                </div>
               
            </div>





            <div className="row g-5 mt-2">
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
                    <div className="team-item bg-light rounded overflow-hidden">
                        <div className="text-center py-4">
                            <h4 className="text-primary">SOUTH AFRICA

                                </h4>
                        </div>
                        <div className="team-img position-relative overflow-hidden">
                            <img className="img-fluid w-100" src="img/sa.png"  style={{height:"290px"}} alt="" />
                          
                        </div>
                     
                    </div>
                    
                </div>
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                    
                    <div className="section-title position-relative pb-3 mb-5">
                        <h1 className="mb-0">UNICELL PAPER MILLS (SA) PTY LTD. 
                        </h1>
                    </div>
                    <p className="mb-4 text-center">UNICELL WAS SET UP IN JOHANNESBURG IN 2000 TO MANUFACTURE 200 TPD OF KRAFT PAPER FOR THE CORRUGATING INDUSTRY. A NEW COMPANY INCORPORATED IN SOUTH AFRICA, IN A PRIME INDUSTRIAL SITE IN GERMISTON, JOHANNESBURG, WITH THIS EXPANSION THE KRAFT PRODUCTION CAPACITY OF THE GROUP IN THE REGION CAME TO 120,000 TONS A YEAR. THE NEW PROJECT COMPLEMENTED AND CONSOLIDATED THE EXISTING KRAFT OPERATIONS ENABLING THEM TO OFFER A BROADER AND SUPERIOR PRODUCT RANGE AT ECONOMICAL PRICES THROUGHOUT THE REGION. DUE TO STRATEGIC REASONS THIS UNIT WAS SOLD IN A PRIVATE DEAL TO A DOWNSTREAM CORRUGATING GROUP IN 2005. 

                    </p>
                    

                    
                </div>
               
            </div>



            

            <div className="row g-5 mt-2">
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">

                    <div className="section-title position-relative pb-3 mb-5">
                        <h1 className="mb-0">UNICELL PAPER MILLS CARIBBEAN LIMITED, ARIMA, TRINIDAD & TOBAGO</h1>
                    </div>
                    <p className="mb-4 text-center">THE ENTERPRISING NATURE OF THE FAMILY SENT ONE OF THE BROTHERS ONTO DEVELOP A GREENFIELD TISSUE MILL PROJECT IN THE CARIBBEAN WHERE THEY SAW A MARKET GAP. WITH EXPENSIVE SHIPPING LANES BETWEEN MAINLAND SOUTH AMERICA AND NORTH AMERICA, VARIOUS CONVERTERS ON DIFFERENT ISLANDS IN THE CARIBBEAN WERE USED TO IMPORTING TISSUE PAPER AT EXORBITANT PRICES FROM USA, CANADA & SOUTH AMERICA. UNICELL PAPER MILLS BECAME THE ONLY MODERN TISSUE PAPER MILL IN THE WHOLE OF THE CARIBBEAN.</p>
                    <p className="mb-4 text-center">LATEST EUROPEAN PAPER MACHINERY WAS INSTALLED OF CAPACITY – 35,000 TONS PER YEAR.</p>
                    <p className="mb-4 text-center">A 15-ACRE SITE WITH ALL INFRASTRUCTURES WAS DEVELOPED AND BECAME ONE OF THE LARGEST FOREIGN INVESTMENTS IN TRINIDAD & TOBAGO IN 2003. THE MILL WAS AWARDED EXPORTER OF THE YEAR 3 YEARS CONSECUTIVELY. THE MILL WAS SUCCESSFULLY COMMISSIONED AND OPERATED UNTIL 2010 WHEN KRUGER GROUP OF CANADA PURCHASED THE MILL FROM THE FAMILY AS PART OF ITS STRATEGY TO BECOME A SERIOUS TISSUE PAPER SUPPLIER IN THE REGION.
                    </p>
                    
                </div>
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                    
                    <div className="team-item bg-light rounded overflow-hidden">
                        <div className="text-center py-4">
                            <h4 className="text-primary">TRINIDAD 
                                & 
                                TOBAGO
                                
                                </h4>
                        </div>
                        <div className="team-img position-relative overflow-hidden">
                            <img className="img-fluid w-100" src="img/tt.png"  style={{height:"550px"}} alt="" />
                          
                        </div>
                     
                    </div>
                   

                    
                </div>
               
            </div>




            <div className="row g-5 mt-2">
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
                    <div className="team-item bg-light rounded overflow-hidden">
                        <div className="text-center py-4">
                            <h4 className="text-primary">ZAMBIA

                                </h4>
                        </div>
                        <div className="team-img position-relative overflow-hidden">
                            <img className="img-fluid w-100" src="img/alpa.png"  style={{height:"290px"}} alt="" />
                          
                        </div>
                     
                    </div>
                    
                </div>
                <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                    
                    <div className="section-title position-relative pb-3 mb-5">
                        <h1 className="mb-0">ALPHA POLYPLAST LTD.  
 
                        </h1>
                    </div>
                    <p className="mb-4 text-center">APL OPERATES A MODERN POST-CONSUMER PET BOTTLE RECYCLING PLANT TO PRODUCE PET FLAKES AND PET STRAPPING USED FOR PACKAGING OF ALL GENERAL AND INDUSTRIAL GOODS. THE FIRST PHASE CAPACITY IS 3000 TONS PER YEAR, WITH OPTIONS TO EXPAND.


                    </p>
                    <p className="mb-4 text-center">THE COMPANY COLLECTS POST-CONSUMER WASTE PET BOTTLES GENERATED BY LUSAKA AND OTHER MAJOR CITIES INCLUDED IN THE CO-MINGLED WASTE STREAM. THE MUNICIPALITIES, MANY BEVERAGE COMPANIES ARE FINDING PET BOTTLE LITTERING TO BE A HUGE PROBLEM. APL EMPLOYS ADULTS, ADULT GROUPS AND INDEPENDENT CONTRACTORS TO COLLECT PET BOTTLES VIA A NETWORK OF COLLECTION SYSTEM THROUGHOUT ZAMBIA. 
                    </p>

                    
                </div>
               
            </div>





            <div className="row g-5 mt-2">
                <div className="col-lg-8 wow slideInUp" data-wow-delay="0.3s">

                    <div className="section-title position-relative pb-3 mb-5">
                        <h1 className="mb-0">MAURITIUS</h1>
                    </div>
                    <p className="mb-4 text-center">UNICELL TECHNOLOGIES LTD CONSULTED TO A PRIVATE EQUITY GROUP BASED IN MAURITIUS TO CONCEPTUALIZE A WASTEPAPER RECYCLING PROJECT TO USE LOCALLY AVAILABLE BROWN WASTEPAPER AND CONVERT INTO KRAFT PACKAGING PAPERS TO SUPPLY LOCAL CORRUGATED BOX MANUFACTURING COMPANIES. KRAFT PAPER BEING IMPORTED INTO MAURITIUS WOULD BE SUBSTITUTED TO A LARGE EXTENT BY WECYCLE MANUFACTURING LIMITED. UNICELL GUIDED THE WHOLE PROCESS OF PLANT DESIGN, MACHINERY SUPPLIER SELECTION, TECHNOLOGY APPLICATION AND OPERATIONAL FACILITATION. 
                
                    </p>
                    <div className="row g-5">
                        <div className="col-lg-6">
                            <div className="team-img position-relative overflow-hidden">
                            <img className="img-fluid w-100" style={{height:"335px"}} src="img/ma1.png" alt="" />
                            </div>

                        </div>
                        <div className="col-lg-6">
                            <div className="team-img position-relative overflow-hidden">
                            <img className="img-fluid w-100"  style={{height:"335px"}} src="img/ma2.png" alt="" />
                            </div>

                        </div>

                    </div>
                    
                </div>
                <div className="col-lg-4 wow slideInUp" data-wow-delay="0.6s">
                    
                    <div className="team-item bg-light rounded overflow-hidden">
                        <div className="text-center py-4">
                            <h4 className="text-primary">MAURITIUS</h4>
                        </div>
                        <div className="team-img position-relative overflow-hidden">
                            <img className="img-fluid w-100" src="img/ma.png" alt="" />
                          
                        </div>
                     
                    </div>
                   

                    
                </div>
               
            </div>



        </div>
    </div>
    </>
    );
}

export default Gallery;